import React from 'react'
import HospitalProfile from '../../components/HospitalProfile/HospitalProfile'

export default function HospitalProfilePage() {
  return (
    <HospitalProfile/>
  )
}
